
const SingleFavorite = props => {
  <h1>Single Favorite</h1>
}

export default SingleFavorite